/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserPointsHistoryPageRespVo
 */
export interface GetUserPointsHistoryPageRespVo {
    /**
     * No
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    id?: number;
    /**
     * 使用区分ID
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    changeReason?: number;
    /**
     * 使用区分
     * @type {string}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    changeReasonDesc?: string;
    /**
     * 用户积分数据 ID
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    pointsId?: number;
    /**
     * 本次变动积分数
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    amount?: number;
    /**
     * 变动后的积分余额
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    principal?: number;
    /**
     * 出入类型：0-出积分，1-入积分
     * @type {number}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    intOutType?: number;
    /**
     * 备注说明
     * @type {string}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    remark?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof GetUserPointsHistoryPageRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the GetUserPointsHistoryPageRespVo interface.
 */
export function instanceOfGetUserPointsHistoryPageRespVo(value: object): value is GetUserPointsHistoryPageRespVo {
    return true;
}

export function GetUserPointsHistoryPageRespVoFromJSON(json: any): GetUserPointsHistoryPageRespVo {
    return GetUserPointsHistoryPageRespVoFromJSONTyped(json, false);
}

export function GetUserPointsHistoryPageRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPointsHistoryPageRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'changeReason': json['changeReason'] == null ? undefined : json['changeReason'],
        'changeReasonDesc': json['changeReasonDesc'] == null ? undefined : json['changeReasonDesc'],
        'pointsId': json['pointsId'] == null ? undefined : json['pointsId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function GetUserPointsHistoryPageRespVoToJSON(json: any): GetUserPointsHistoryPageRespVo {
    return GetUserPointsHistoryPageRespVoToJSONTyped(json, false);
}

export function GetUserPointsHistoryPageRespVoToJSONTyped(value?: GetUserPointsHistoryPageRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'changeReason': value['changeReason'],
        'changeReasonDesc': value['changeReasonDesc'],
        'pointsId': value['pointsId'],
        'amount': value['amount'],
        'principal': value['principal'],
        'intOutType': value['intOutType'],
        'remark': value['remark'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

